<span>{{ this.valore == "-" ? this.valore : (this.valore | number: '1.0-2') }}</span>